export function Footer() {
  return (
    <footer className='border-t border-border bg-white'>
      <div className='mx-auto flex max-w-[960px] items-center justify-center gap-4 px-6 py-6 text-sm text-text-secondary'>
        <a
          href='https://www.tonome.jp/betatos'
          target='_blank'
          rel='noopener noreferrer'
          className='transition-colors hover:text-text'
        >
          利用規約
        </a>
        <span className='text-text-secondary'>|</span>
        <a
          href='https://www.tonome.jp/privacypolicy'
          target='_blank'
          rel='noopener noreferrer'
          className='transition-colors hover:text-text'
        >
          プライバシーポリシー
        </a>
      </div>
    </footer>
  );
}
